// src/components/ProductsChart.js
import React, { useEffect, useState } from "react";
import { getProducts } from "../api";
import { Pie } from "react-chartjs-2";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  Title,
} from "chart.js";

ChartJS.register(ArcElement, Tooltip, Legend, Title);

function ProductsChart() {
  const [categoryCounts, setCategoryCounts] = useState({});

  useEffect(() => {
    getProducts().then(data => {
      const counts = {};
      data.forEach(p => {
        counts[p.category] = (counts[p.category] || 0) + 1;
      });
      setCategoryCounts(counts);
    });
  }, []);

  const chartData = {
    labels: Object.keys(categoryCounts),
    datasets: [
      {
        label: "Products by Category",
        data: Object.values(categoryCounts),
        backgroundColor: ["#36A2EB", "#FF6384", "#FFCE56"],
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      title: {
        display: true,
        text: "Product Categories",
      },
    },
  };

  return (
    <div style={{ marginTop: "30px" }}>
      <h2>Products Chart</h2>
      <Pie data={chartData} options={options} />
    </div>
  );
}

export default ProductsChart;
